import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { tss } from "tss-react";
import { DataGrid } from "components";
import ApiUtils from "api/Utils";
import commonStyles from "styles/common";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

const useStyles = tss.create(() => ({
    report: {
        display: "inline-flex",
        verticalAlign: "top",
        justifyContent: "center",
    },
    table: {
        padding: 0,
        maxWidth: "100%",
    },
    td: {
        height: 25,
        minWidth: 145,
        maxWidth: 300,
    },
    tdBorder: {
        borderBottom: "solid 1px #d1d1d1",
        padding: 10,
    },
    tabsContent: {
        minHeight: 200,
        width: "100%",
        height: "100vh",
        paddingTop: 0,
        //backgroundColor: "white",
        borderTop: "solid 1px #f0f0f0",
        display: "flex",
    },
}));

type IProps = {
    entity: any;
    maxWidth?: any;
    maxHeight?: any;
};

export default function Report(props: IProps) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { entity, maxWidth, maxHeight } = props;
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<any>([]);
    const [columns, setColumns] = useState<any>([]);
    const entityId = entity["ID"];
    const projectId = entity["project"];
    useEffect(() => {
        setLoading(true);
        ApiUtils.fetchReportCSV(projectId, entityId).then((csv: any) => {
            //console.log("csv:", csv);
            if (csv !== "") {
                var lines = csv.split(/\r?\n/);
                if (lines.length > 0) {
                    var cols: any = [];
                    lines[0].split(",").forEach((fieldName: string) => {
                        if (fieldName !== "") {
                            cols.push({ field: fieldName });
                        }
                    });
                    var rows: any = [];
                    var isValid: boolean = false;
                    lines.forEach((line: any, index: number) => {
                        if (index > 0) {
                            var obj: any = {};
                            var values = line.split(",");
                            isValid = values.length === cols.length;
                            values.forEach((value: string, colIdx: number) => {
                                if (cols[colIdx] && cols[colIdx]["field"]) {
                                    obj[cols[colIdx]["field"]] = value;
                                }
                            });
                            if (isValid) {
                                rows.push(obj);
                            }
                        }
                    });
                    setColumns(cols);
                    //console.log("rows:", rows);
                    setRows(rows);
                    setLoading(false);
                }
            } else {
                setColumns([]);
                setRows([]);
                setLoading(false);
            }
        });
    }, [projectId, entityId]);

    if (!entityId) {
        return <div />;
    }
    return (
        <div role="tabpanel" className={classes.tabsContent} style={{ maxHeight: maxHeight, maxWidth: maxWidth }}>
            {loading ? (
                <div className={common.middleCenter} style={{ width: "100%", height: "100%" }}>
                    <CircularProgress />
                </div>
            ) : rows.length === 0 ? (
                <div style={{ width: "100%", paddingLeft: 20 }}>No Data</div>
            ) : (
                <div
                    style={{
                        height: rows.length > 10 ? "100%" : rows.length * 81,
                        width: "100%", //columns.length > 5 ? "100%" : columns.length * 218,
                        maxWidth: maxWidth,
                        maxHeight: maxHeight,
                        minHeight: 110,
                    }}
                >
                    <div className={"ag-theme-material"} style={{ width: "100%", height: "100%" }}>
                        <DataGrid rows={rows} columns={columns} maxWidth={maxWidth} maxHeight={maxHeight} />
                    </div>
                </div>
            )}
        </div>
    );
}
